import _typeof from 'babel-runtime/helpers/typeof';
import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import createCustomizedBodyWrapper from './createCustomizedBodyWrapper';
import VirtualList from './VirtualList';

export default function createBodyWrapper() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tbody';

  var BodyWrapper = {
    name: 'BodyWrapper',

    components: {
      'virtual-list': VirtualList
    },

    inject: {
      table: { 'default': function _default() {
          return {};
        } }
    },

    render: function render() {
      var _this = this;

      var h = arguments[0];

      var transfer_size = 54,
          transfer_remain = 8,
          transfer_bench = 16;
      var _table = this.table,
          rowDraggable = _table.rowDraggable,
          virtual = _table.virtual;

      if (rowDraggable) {
        var _table2 = this.table,
            dataSource = _table2.dataSource,
            sortOrder = _table2.sortOrder;

        var CustomizedBodyWrapper = createCustomizedBodyWrapper(Component);

        return h(
          CustomizedBodyWrapper,
          _mergeJSXProps([this.$props, {
            attrs: {
              rowDraggable: rowDraggable,
              dataSource: dataSource,
              sortOrder: sortOrder
            }
          }]),
          [this.$slots['default']]
        );
      }

      if ((typeof virtual === 'undefined' ? 'undefined' : _typeof(virtual)) === 'object') {
        var size = virtual.size,
            remain = virtual.remain,
            bench = virtual.bench;


        transfer_size = size;
        transfer_remain = remain;
        transfer_bench = bench;
      }

      var listeners = {
        'update:paddingTop': function updatePaddingTop(val) {
          _this.table.baseTableWrapperPaddingTop = val;
        },
        'update:paddingBottom': function updatePaddingBottom(val) {
          _this.table.baseTableWrapperPaddingBottom = val;
        }
      };

      return virtual ? h(
        'virtual-list',
        _mergeJSXProps([{
          attrs: {
            paddingTop: this.table.baseTableWrapperPaddingTop,
            paddingBottom: this.table.baseTableWrapperPaddingBottom,
            pagemode: true,
            target: this.table.ref_bodyTable,
            wtag: Component,
            wtagProps: this.$props,
            size: transfer_size,
            remain: transfer_remain,
            bench: transfer_bench
          }
        }, { on: listeners }]),
        [this.$slots['default']]
      ) : h(
        Component,
        this.$props,
        [this.$slots['default']]
      );
    }
  };

  return BodyWrapper;
}